
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!assignments.post_to_sis_selector";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'assignments/PostToSisSelector';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<div class=\"form-column-left no-group\">\n  "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'postToSISName': ((depth0 && depth0.postToSISName)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "sync_to_posttosisname_dffd5c9", "Sync to %{postToSISName}", options) : helperMissing.call(depth0, "t", "sync_to_posttosisname_dffd5c9", "Sync to %{postToSISName}", options)))
    + "\n</div>\n\n<div class=\"form-column-right\">\n  <label class=\"checkbox flush\" for=\"assignment_post_to_sis\">\n    "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'id': ("assignment_post_to_sis"),
    'prefix': ((depth0 && depth0.prefix)),
    'checked': ((depth0 && depth0.postToSIS))
  },data:data},helper ? helper.call(depth0, "post_to_sis", options) : helperMissing.call(depth0, "checkbox", "post_to_sis", options)))
    + "\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "include_this_assignment_s_grades_when_syncing_to_y_55bfa487", "Include this assignment's grades when syncing to your school's Student Information System", options) : helperMissing.call(depth0, "t", "include_this_assignment_s_grades_when_syncing_to_y_55bfa487", "Include this assignment's grades when syncing to your school's Student Information System", options)))
    + "\n  </label>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  